import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgSelectModule} from '@ng-select/ng-select';
import {SharedModule} from '@shared/shared.module';
import {UserComponent} from '@components/administration/user/user.component';
import {UserActionComponent} from '@components/administration/user/user-action/user-action.component';
import {UserEditComponent} from '@components/administration/user/modal/user-edit.component';
import {UserRoutingModule} from '@components/administration/user/user-routing.module';
import {UsersBanModalComponent} from './modal/users-ban-modal/users-ban-modal.component';


@NgModule({
  declarations: [
    UserComponent,
    UserActionComponent,
    UserEditComponent,
    UsersBanModalComponent
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    TranslateModule,
    NgbModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [
    UserComponent
  ]
})
export class UserModule {
}
